const AdmPostagens = () => {
  return <div>adm Postagens</div>;
};
export default AdmPostagens;
